import { Select, Spin } from "antd";
import NoDataComponent from "./NoData";
import i18n from "i18next";

const { Option } = Select;

interface CommonMultiSelectProps<T> {
  value?: T[]; // Selected values
  onChange?: (value: T[]) => void; // Handle selection changes
  onSearch?: (query: string) => void; // Handle search input
  placeholder?: string; // Placeholder text
  loading?: boolean; // Show loading spinner
  options: { value: T; label: string }[]; // Data list
  disabled?: boolean; // Disable the select
}

const CommonMultiSelect = <T extends string | number>({
  value,
  onChange,
  onSearch,
  placeholder = i18n.t("select_item"),
  loading = false,
  options,
  disabled = false,
}: CommonMultiSelectProps<T>) => {
  return (
    <Select
    disabled={disabled}
      mode="multiple"
      showSearch
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onSearch={onSearch}
      notFoundContent={loading ? <Spin size="small" /> : <NoDataComponent />}
      filterOption={false}
      style={{ width: "100%" }}
      tagRender={({ label }) => (
        <span className="badge bg-outline-primary">{label}</span> // ✅ Styled as Bootstrap badge
      )}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default CommonMultiSelect;
